const getQueryParam = key => {
    const currentUrl = window.location.href;
    const params = new URLSearchParams(currentUrl.split('?')[1]);
    return params.get(key) || null;
};

export default getQueryParam;
